import Star from "@mui/icons-material/Star";
import cx from "classnames";
import FieldWrapper from "../components/FieldWrapper";
import Icon from "../components/Icon";
import { RatingFieldType } from "../types/feedbackFields.types";
import { FieldValueProps } from "./fields.types";
import { withSingleValue } from "./fields.utils";

// TODO: handle required
const RatingField = ({ field, value, error, onChange }: { field: RatingFieldType } & FieldValueProps<number>) => {
  const { _id, name, max, ratingIcon, iconColor } = field;
  const id = _id || name;
  const useStarSvg = !ratingIcon || ratingIcon === "star";

  const buttons = [];
  for (let i = 1; i <= max; i++) {
    const checked = value && i <= value;
    const sharedProps = {
      key: i,
      className: cx("rating-star", { checked }),
      style: { color: checked ? iconColor : undefined },
      onTouchStart: () => onChange(id, i),
      onClick: () => onChange(id, i),
    };

    buttons.push(
      useStarSvg ? (
        <span {...sharedProps} >
          <Star />
        </span>
      ) : (
        <Icon name={ratingIcon || "star"} {...sharedProps} />
      ),
    );
  }

  return (
    <FieldWrapper field={field} error={error}>
      <div id={id} className={`rating rating-size--${max > 5 ? "small" : "normal"}`}>
        {buttons}
      </div>
      <div className="rating__label"></div>
    </FieldWrapper>
  );
};
export default withSingleValue(RatingField);
